
import Header from '../../components/feature/Header';
import HeroSectionNew from './components/HeroSectionNew';
import FeaturesGridSection from './components/FeaturesGridSection';
import HowItWorksSection from './components/HowItWorksSection';
import TopDealsSection from './components/TopDealsSection';
import TestimonialsSection from './components/TestimonialsSection';
import NewsletterSection from './components/NewsletterSection';
import Footer from '../../components/feature/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSectionNew />
      <FeaturesGridSection />
      <TopDealsSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <NewsletterSection />
      <Footer />
    </div>
  );
};

export default HomePage;
